import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatComponent, CopilotFacadeService } from '@brighthub/copilot';
import {
  ConversationListComponent,
  ConversationService,
} from '@brighthub/brightai-conversation-search';
import { BrightaiLayoutComponent } from '../brightai-layout/brightai-layout.component';
import { BrightaiLayoutService } from '../brightai-layout.service';
import { ActivatedRoute } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { map, take, tap } from 'rxjs';
import { GenericResponseCode } from '@brighthub/api';
import { ClientSessionService, UiSession } from '@brighthub/uisession';

@Component({
  selector: 'bai-conversation-layout',
  imports: [
    CommonModule,
    ConversationListComponent,
    BrightaiLayoutComponent,
    ChatComponent,
  ],
  templateUrl: './conversation-layout.component.html',
  styleUrl: './conversation-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConversationLayoutComponent {
  layoutService = inject(BrightaiLayoutService);
  collapsed = computed(()=> this.layoutService.collapsed());
  private _route = inject(ActivatedRoute);
  conversationId = toSignal(
    this._route.paramMap.pipe(map(params => params.get('conversationId')))
  );

  private _conversationService: ConversationService = inject(ConversationService);
  private _copilotFacadeService = inject(CopilotFacadeService);
  private _clientService = inject(ClientSessionService);

  constructor() {
    this._copilotFacadeService.hideInput.set(true);
    effect(() => {
      const id = this.conversationId();
      const activeConvo = this._conversationService.activeConversation();
      if (activeConvo && id === activeConvo.conversationId) {
        this.setConversation(activeConvo);
      } else if (id){
        this._conversationService.getConversationById(id);
      } else if (activeConvo) {
        this.setConversation(activeConvo);
      }

      if (!id && !activeConvo) {
        this._copilotFacadeService.clearContext();
      }

    });
  }

  setConversation(uiSession: UiSession) {
    this._copilotFacadeService.loadAndSelectConversation(uiSession.subjectId, uiSession.conversationId!);
    this._clientService.setSelectedSubject(uiSession.subjectData);
  }
}
